// Bộ nhãn dán Gạo Nâu cho chat khách ("ô cửa sổ hoa leo", CEO chốt 28/09/2026).
//
// Nhãn dán gửi đi dưới dạng ẢNH qua đường tải ảnh đang có — không thêm loại tin
// mới, nên phía khách (Cổng) lẫn phía nhân viên đọc được ngay. Ảnh vẽ bằng
// `scripts/nhan-dan/ve.mjs`; cùng bộ ảnh chép sang kho Cổng.
import camOn from "@/assets/nhan-dan/cam-on.png";
import choChut from "@/assets/nhan-dan/cho-chut.png";
import chotAnh from "@/assets/nhan-dan/chot-anh.png";
import depQua from "@/assets/nhan-dan/dep-qua.png";
import henGap from "@/assets/nhan-dan/hen-gap.png";
import thuongGaoNau from "@/assets/nhan-dan/thuong-gao-nau.png";

export type Sticker = { key: string; label: string; src: string };

export const STICKERS: readonly Sticker[] = [
  { key: "cam-on", label: "Cảm ơn nha!", src: camOn },
  { key: "dep-qua", label: "Đẹp quá trời!", src: depQua },
  { key: "chot-anh", label: "Chốt ảnh này", src: chotAnh },
  { key: "cho-chut", label: "Chờ em chút xíu", src: choChut },
  { key: "hen-gap", label: "Hẹn gặp ở studio", src: henGap },
  { key: "thuong-gao-nau", label: "Thương Gạo Nâu", src: thuongGaoNau },
];

/** Tải ảnh nhãn dán thành File để đi đúng đường gửi ảnh. Lỗi mạng thì ném, nơi gọi báo lỗi. */
export async function stickerFile(sticker: Sticker): Promise<File> {
  const res = await fetch(sticker.src);
  if (!res.ok) throw new Error("Không tải được nhãn dán — kiểm tra mạng rồi thử lại");
  const blob = await res.blob();
  return new File([blob], `nhan-dan-${sticker.key}.png`, { type: "image/png" });
}
